import { createFeature, createReducer, on } from '@ngrx/store';
import { DebitNoteModel } from '@shared/data-access/models';
import { DebitNoteAction } from '../actions';

export const featureName = 'debitNote';

export interface DataState {
  item: DebitNoteModel | null;
}

export const initialState: DataState = {
  item: null,
};

export const debitNoteFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(DebitNoteAction.loadItemSuccess, (state, prop: { item: DebitNoteModel }) => ({ ...state, item: prop.item }))
  ),
});

export const { name, reducer } = debitNoteFeature;
